import { Switch } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { renderInputBody } from "../helper";

const Style = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;

  .label-cont {
    flex: 1;
  
    h3 {
      font-size: var(--font-size-lg);
      font-weight: 500;
      margin-bottom: 4px;
    }

    p {
      color: #6C737F;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export default function FormSwitch({ data = {}, input = {}, onChange = () => { } }) {
  const { t } = useTranslation();
  const disabled = input.disabled;

  const body = (
    <div className="flex flex-1 flex-column justify-content-center">
      <Switch
        disabled={input.disabled}
        size="large"
        checked={data[input.key]}
        defaultChecked={input.defaultChecked}
        placeholder={t(input.placeholder || input.label)}
        onChange={(e) => onChange({ [input.key]: e })} />
    </div>
  )

  return (
    <Style>
      <div className="label-cont">
        <h3>{t(input.label)}</h3>
        <p>{t(input.subLabel)}</p>
      </div>
      <div className="flex flex-column justify-content-center">
        {renderInputBody({ t, disabled, body })}
      </div>
    </Style>
  );
}
